// extracted by mini-css-extract-plugin
export default {"textField":"TitleTaxInformationSection_textField__99el0","button":"TitleTaxInformationSection_button__xoWxx"};